import { Outlet } from 'react-router-dom-v6'
import { useTranslation } from 'react-i18next'
import { Button, Separator, SidebarInset, SidebarProvider, SidebarTrigger } from '@clouway/ui'
import { LogOut } from 'lucide-react'

import { useSession } from '@/features/auth'
import AppSidebar from './AppSidebar'
import ModeToggle from './ModeToggle'

function AppLayout() {
  const { t } = useTranslation('common')
  const { logout } = useSession()

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-12 shrink-0 items-center gap-2 border-b px-4">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mr-2 h-4" />
          <div className="ml-auto flex items-center gap-1">
            <ModeToggle />
            <Button variant="ghost" size="icon" aria-label={t('ui.button.logout')} onClick={() => void logout()}>
              <LogOut className="size-4" />
            </Button>
          </div>
        </header>
        <div className="flex flex-1 flex-col p-4">
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}

export default AppLayout
